module.exports = __webpack_public_path__ + "img/PointBtoA.21f0903d.png";